import { render, staticRenderFns } from "./SettingsNavbar.vue?vue&type=template&id=401e996c&scoped=true"
import script from "./SettingsNavbar.vue?vue&type=script&lang=js"
export * from "./SettingsNavbar.vue?vue&type=script&lang=js"
import style0 from "./SettingsNavbar.vue?vue&type=style&index=0&id=401e996c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e996c",
  null
  
)

export default component.exports